(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tam-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tam-review-carousel')) {
    class TamReviewCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialised) {
          if (this.onBlockSelect) document.addEventListener('shopify:block:select', this.onBlockSelect);
          return;
        }
        this.initialised = true;
        this.viewport = this.querySelector('.tam-rc__viewport');
        this.track = this.querySelector('.tam-rc__track');
        this.dots = Array.from(this.querySelectorAll('.tam-rc__dot'));
        this.speed = parseInt(this.dataset.speed, 10) || 500;
        const slides = Array.from(this.track.children);
        this.count = slides.length;
        if (this.count < 2) return;

        const firstClone = slides[0].cloneNode(true);
        const lastClone = slides[this.count - 1].cloneNode(true);
        [firstClone, lastClone].forEach((c) => {
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
        });
        this.track.appendChild(firstClone);
        this.track.insertBefore(lastClone, slides[0]);

        this.position = 1;
        this.busy = false;
        this.setPosition(false);

        this.querySelector('.tam-rc__arrow--prev').addEventListener('click', () => this.go(this.position - 1));
        this.querySelector('.tam-rc__arrow--next').addEventListener('click', () => this.go(this.position + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i + 1)));
        this.track.addEventListener('transitionend', (e) => { if (e.target === this.track) this.onSettled(); });
        this.bindDrag();

        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          const real = Array.from(this.track.children).slice(1, this.count + 1);
          const idx = real.indexOf(e.target);
          if (idx > -1) this.go(idx + 1);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        clearTimeout(this.settleTimer);
        this.busy = false;
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      setPosition(animate, offset = 0) {
        this.track.style.transition = animate ? `transform ${this.speed}ms ease-in` : 'none';
        this.track.style.transform = `translate3d(calc(${-this.position * 100}% + ${offset}px), 0, 0)`;
      }

      go(target) {
        if (this.busy) return;
        if (target === this.position) return;
        this.position = target;
        this.animate();
        this.updateDots();
      }

      animate() {
        this.busy = true;
        this.setPosition(true);
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.onSettled(), this.speed + 100);
      }

      onSettled() {
        if (!this.busy) return;
        clearTimeout(this.settleTimer);
        if (this.position === 0) this.position = this.count;
        if (this.position === this.count + 1) this.position = 1;
        this.setPosition(false);
        this.busy = false;
      }

      updateDots() {
        const real = ((this.position - 1 + this.count) % this.count);
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === real));
      }

      bindDrag() {
        let startX = 0;
        let startY = 0;
        let dx = 0;
        let dragging = false;
        let horizontal = null;
        const down = (e) => {
          if (this.busy) return;
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          dragging = true;
          horizontal = null;
          startX = e.clientX;
          startY = e.clientY;
          dx = 0;
        };
        const move = (e) => {
          if (!dragging) return;
          const mx = e.clientX - startX;
          const my = e.clientY - startY;
          if (horizontal === null && (Math.abs(mx) > 5 || Math.abs(my) > 5)) {
            horizontal = Math.abs(mx) > Math.abs(my);
            if (horizontal) {
              this.viewport.classList.add('is-dragging');
              try { this.viewport.setPointerCapture(e.pointerId); } catch (err) {}
            }
          }
          if (!horizontal) return;
          dx = mx;
          this.setPosition(false, dx);
        };
        const up = () => {
          if (!dragging) return;
          dragging = false;
          this.viewport.classList.remove('is-dragging');
          if (!horizontal) return;
          const threshold = Math.min(80, this.viewport.offsetWidth * 0.15);
          if (dx <= -threshold) this.go(this.position + 1);
          else if (dx >= threshold) this.go(this.position - 1);
          else this.animate();
        };
        this.viewport.addEventListener('pointerdown', down);
        this.viewport.addEventListener('pointermove', move);
        this.viewport.addEventListener('pointerup', up);
        this.viewport.addEventListener('pointercancel', up);
        this.viewport.addEventListener('pointerleave', up);
      }
    }
    customElements.define('tam-review-carousel', TamReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
